module.exports = __webpack_public_path__ + "media/images/index/post-abefa5407db325c432f1eede55d6c23b.svg";